/**
 * Pure display logic for the Usage page's stat cards. No React, no imports from
 * component files, so this stays node-testable.
 */

export function seatPhrase(occupied: number, purchased: number): string {
  return `${occupied} / ${purchased}`;
}
